import {
  TEntityResponse,
  TEntityListResponse,
  TCreateFlowActionReqBody,
  TFlowActionResBody,
  TFlowActionSummaryResBody,
  TUpdateFlowActionReqBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TFlowActionsClient = {
  create(
    body: TCreateFlowActionReqBody,
    dry: boolean
  ): Promise<TEntityResponse<'flow-action', TFlowActionResBody> | undefined>;
  update(
    id: string,
    body: TUpdateFlowActionReqBody,
    dry: boolean
  ): Promise<TEntityResponse<'flow-action', TFlowActionResBody> | undefined>;
  delete(id: string): Promise<void>;
  get(id: string): Promise<TEntityResponse<'flow-action', TFlowActionResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'flow-action', TFlowActionSummaryResBody> | undefined>;
};

function FlowActionsClient(apiClient: TAPIClient): TFlowActionsClient {
  return {
    async create(
      body: TCreateFlowActionReqBody,
      _dry?: boolean
    ): Promise<TEntityResponse<'flow-action', TFlowActionResBody> | undefined> {
      const data = await apiClient.post<TCreateFlowActionReqBody, TEntityResponse<'flow-action', TFlowActionResBody>>(
        '/flow-actions',
        body
      );

      if (data && data.type !== 'flow-action') {
        throw new Error('Invalid entity type received, expected: flow-action, received: ' + data.type);
      }

      return data;
    },

    async update(
      id: string,
      body: TUpdateFlowActionReqBody,
      _dry?: boolean
    ): Promise<TEntityResponse<'flow-action', TFlowActionResBody> | undefined> {
      const data = await apiClient.put<TUpdateFlowActionReqBody, TEntityResponse<'flow-action', TFlowActionResBody>>(
        `/flow-actions/${id}`,
        body
      );

      if (data && data.type !== 'flow-action') {
        throw new Error('Invalid entity type received, expected: flow-action, received: ' + data.type);
      }

      return data;
    },

    async delete(id: string): Promise<void> {
      return await apiClient.delete(`/flow-actions/${id}`);
    },

    async get(id: string): Promise<TEntityResponse<'flow-action', TFlowActionResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'flow-action', TFlowActionResBody>>(`/flow-actions/${id}`);

      if (data && data.type !== 'flow-action') {
        throw new Error('Invalid entity type received, expected: flow-action, received: ' + data.type);
      }

      return data;
    },

    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'flow-action', TFlowActionSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'flow-action', TFlowActionSummaryResBody>>(
        `/flow-actions?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'flow-action') {
        throw new Error('Invalid entity type received, expected: flow-action, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TFlowActionsClient, FlowActionsClient };
